import { render, staticRenderFns } from "./view_detail.vue?vue&type=template&id=903d46ae&"
import script from "./view_detail.vue?vue&type=script&lang=js&"
export * from "./view_detail.vue?vue&type=script&lang=js&"
import style0 from "./view_detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports